import Type from "@/model/types/Type";

const type = {

    NONE : 0,
    RUNNING : 1,
    WAITING : 2,

}

const list = [
    {
        value: type.NONE,
        text: "Nenhum",
    },
    {
        value: type.RUNNING,
        text: "Em execução",
    },
    {
        value: type.WAITING,
        text: "Aguardando início",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


